import { connect } from "react-redux";
import InspectionForm from "./inspectionForm";
import { bindActionCreators } from "redux";
import { viewAssigneeData} from "services/redux/maintenance/inspectionRequests/action";
import { viewSiteInspectionForms } from "services/redux/sales/postSaleListing/action";
import { setInspectionForm, viewInspectionForm} from "services/redux/maintenance/inspectionForm/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    siteInspectionList: state.postSalesListReducer.siteInspectionList,
    viewInspectionForms: state.InspectionReducer.viewInspectionForms,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        viewAssigneeData,
        viewSiteInspectionForms,
        setInspectionForm,
        viewInspectionForm,
        documentUploadUrlPublic
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InspectionForm);
